import SelectField from "components/form-control/Select";
import VVSTable from "components/form-control/VVSTable";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";

const FILTER_CONTRACT_OPTIONS = [
  { index: 1, name: "Đã Yêu Cầu", value: "unfinished" },
  { index: 2, name: "Đã hoàn thành", value: "completed" },
  { index: 3, name: "Tất cả", value: "all" },
];

const TRANSACTION_TYPE = {
  deposit: "deposit",
  withdraw: "withdraw",
  pay: "pay",
};

export default function TransactionMoney() {
  const { hash } = useLocation();
  const [filter, setFilter] = useState("");
  const { register } = useForm({});

  const getFilterData = type => {
    if (type === "unfinished") {
      return {
        status: "requested",
      };
    }
    if (type === "completed") {
      return {
        status: "completed",
      };
    }
    if (type === "all") {
      return {};
    }
    return {
      status: "requested",
    };
  };

  useEffect(() => {
    if (filter?.target?.value) {
      getFilterData(filter?.target?.value);
    }
  }, [filter?.target?.value]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row
            style={{
              position: "relative",
              marginBottom: "-35px",
              zIndex: 99,
              width: "max-content",
            }}
          >
            <h4 className="my-0 font-size-18 text-capitalize mb-2">
              Danh sách yêu cầu{" "}
              {hash?.slice(1) === TRANSACTION_TYPE.deposit
                ? "Nạp tiền"
                : hash?.slice(1) === TRANSACTION_TYPE.withdraw
                ? "Rút tiền"
                : hash?.slice(1) === TRANSACTION_TYPE.pay
                ? "Thanh toán"
                : ""}
            </h4>
            <Col sm={6}>
              <SelectField
                name="filter"
                options={FILTER_CONTRACT_OPTIONS}
                register={register}
                onChange={setFilter}
              />
            </Col>
          </Row>
          <VVSTable
            name="Transaction"
            disableAdd
            filter={{
              field: "type",
              defaultValue: hash?.slice(1) || "",
            }}
            whereQuery={getFilterData(filter?.target?.value)}
          />
        </Container>
      </div>
    </React.Fragment>
  );
}
